import { createSelector } from 'reselect';

import { State } from '../types';
import { isValidTCString } from '@wetransfer/transfer/modules/consent-manager/tc-model';

export const selectConsent = (state: State): State['consent'] => state.consent;

export const selectIsConsentCookieOverlayActive = createSelector(
  selectConsent,
  (consent) => consent?.uiVisible
);

export const selectTCString = createSelector(
  selectConsent,
  (consent): string | undefined => consent.tcString
);

export const selectIsValidTCString = createSelector(
  selectConsent,
  (consent): boolean => isValidTCString(consent.tcString || '')
);
